import { EmailType } from '@packlink/packlink-sdk';

export const mapLocationToEmailType = (emailFromLocation?: string): EmailType | undefined => {
    switch (emailFromLocation) {
        case 'label-created':
            return EmailType.BRANDED_SHIPMENT_CONFIRMATION;
        default:
            return undefined;
    }
};
